import React from 'react'
import moment from 'moment'

import {
    Card as ChakraCard,
    Checkbox,
    Flex,
    Box,
    Heading,
    UnorderedList,
    ListItem,
    Icon,
    Tooltip,
    useDisclosure,
    Collapse,
    AlertDialogOverlay,
    AlertDialogContent,
    AlertDialogHeader,
    AlertDialogBody, AlertDialogFooter, Button, AlertDialog,
} from "@chakra-ui/react";
import {
    VscTrash as DeleteIcon,
    VscInfo as InfoIcon,
} from "react-icons/vsc";

import { useGroupAccount } from "../../contexts/GroupAccountContextProvider";
import {MetaDataText} from "../metadata_text";

export const User = ({ user, onSelect, selected, onDelete }) => {

    const { deleteUsers } = useGroupAccount();
    const cancelRef = React.useRef();
    const { isOpen, onOpen, onClose } = useDisclosure();

    const infoDisclosure = useDisclosure();
    const isInfoOpen = infoDisclosure.isOpen;
    const onInfoToggle = infoDisclosure.onToggle;

    return (
        <>
            <ChakraCard
                width="100%"
                marginY={2}
                padding={2}
                gap={2}
                shadow="md"
            >
                <Flex
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Flex
                        alignItems="center"
                        gap={4}
                    >
                        <Box width={4}>
                            <Checkbox
                                isChecked={selected}
                                onChange={(e) => {
                                    onSelect(user.userId, e.target.checked)
                                }}
                            />
                        </Box>
                        <Box>
                            <Heading as="h2" fontSize="xl">{user.firstName} {user.lastName}</Heading>
                            <MetaDataText>{user.email}</MetaDataText>
                        </Box>
                    </Flex>
                    <Flex gap={4}>
                        <Tooltip label="Extended user information">
                            <span>
                                <Icon
                                    as={InfoIcon}
                                    onClick={onInfoToggle}
                                />
                            </span>
                        </Tooltip>
                        <Tooltip label="Delete user">
                            <span>
                                <Icon as={DeleteIcon} onClick={onOpen}/>
                            </span>
                        </Tooltip>
                    </Flex>
                </Flex>
                <Collapse in={isInfoOpen} animateOpacity>
                    <Box>
                        <UnorderedList
                            listStyleType="none"
                        >
                            <ListItem><strong>Phone:</strong> {user.phone}</ListItem>
                            <ListItem><strong>Birth date:</strong> {user.dob}</ListItem>
                            <ListItem><strong>Country:</strong> {user.country}</ListItem>
                            <ListItem><strong>Created at:</strong> {moment(user.createdAt * 1000).format("YYYY-MM-DD HH:mm:ss")}</ListItem>
                        </UnorderedList>
                    </Box>
                </Collapse>
            </ChakraCard>
            <AlertDialog
                isOpen={isOpen}
                aria-labelledby="form-dialog-title"
                onClose={() => {
                    onClose();
                }}
                leastDestructiveRef={cancelRef}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader id="form-dialog-title">Are you sure?</AlertDialogHeader>
                        <AlertDialogBody>
                            This action will remove the selected user from the group account.
                        </AlertDialogBody>
                        <AlertDialogFooter gap={4}>
                            <Button
                                colorScheme="red"
                                onClick={() => {
                                    onClose();
                                    deleteUsers([user.userId]).then(() => {
                                        onDelete()
                                    })
                                }}
                            >
                                Yes
                            </Button>
                            <Button
                                onClick={onClose}
                                ref={cancelRef}
                            >
                                No
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>
        </>
    )
}
export default User